export default "__VITE_ASSET__xwA5s0J$__"